import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

/**
 * Pipe for adding safeHtml to innerHtml attributes.
 *
 * @example <div [innerHtml]="'text-that-has-html' | translate | safeHtml"></div>
 * @example <div [innerHtml]="'<p style="font-size: 12px">bla</p>' | safeHtml"></div>
 */
@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform  {
  /**
   * constructor
   * @param sanitized
   */
  constructor(private sanitized: DomSanitizer) {}

  /**
   * @inheritDoc
   * @param value
   */
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
